import { useEffect, useState } from "react";

// import { useTheme } from '@/theme/useTheme.tsx'
import type { IThemeModeEnum } from ".";

import { useUIStore } from "@/stores/uiStore";

export function isDarkMode(theme: IThemeModeEnum): boolean {
  const splittedTheme = theme.split("-");

  return splittedTheme[1].toUpperCase() !== "LIGHT";
}

/**
 *
 * custom hook that compute given css variable color value
 *
 * @param name
 * css variable name which is defined in theme.scss file, or you can use colors from color.scss
 */
export const useThemeVariable = (name: string) => {
  const [color, setColor] = useState(getColor(name));

  // const { theme } = useTheme()
  const theme = useUIStore((state) => state.theme);

  useEffect(() => {
    setTimeout(() => {
      setColor(getColor(name));
    }, 100);
  }, [name, theme]);

  const hexColor = rgbStringToHexColor(color);

  return { color: hexColor };
};

/**
 * function that gets css variables value from root element
 *
 * @param name
 * css variable name which is defined in theme.scss file, or you can use colors from color.scss
 */
const getColor = (name: string) => {
  const icon = document.querySelector("#root");

  return icon
    ? getComputedStyle(icon).getPropertyValue(`${name}`)
    : getComputedStyle(document.documentElement).getPropertyValue(`${name}`);
};

export function rgbStringToHexColor(rgbString: string): string {
  // Split the input string into an array of individual values
  const rgbArray = rgbString.split(",").map((value) => value.trim());

  // Ensure there are exactly three values
  if (rgbArray.length !== 3) {
    return rgbString;
  }

  // Parse the values as numbers
  const red = Number.parseInt(rgbArray[0]);
  const green = Number.parseInt(rgbArray[1]);
  const blue = Number.parseInt(rgbArray[2]);

  // Ensure the parsed values are within the valid range (0-255)
  if (
    Number.isNaN(red) ||
    Number.isNaN(green) ||
    Number.isNaN(blue) ||
    red < 0 ||
    red > 255 ||
    green < 0 ||
    green > 255 ||
    blue < 0 ||
    blue > 255
  ) {
    return "";
  }

  // Convert each component to a two-digit hexadecimal string
  const rHex = red.toString(16).padStart(2, "0");
  const gHex = green.toString(16).padStart(2, "0");
  const bHex = blue.toString(16).padStart(2, "0");

  // Combine the hexadecimal values and return the color string
  return `#${rHex}${gHex}${bHex}`;
}
